import {
  ExerciseAssetCoachInfoDto,
  LibraryPrivacy,
} from "@growth-machine-llc/stridist-api-client";
import React from "react";
import {
  LibraryPrivacyBadge,
  privacyTooltip,
} from "../badge/LibraryPrivacyBadge";

interface IExercisePrivacyBadgeProps {
  privacy: LibraryPrivacy;
  coach?: ExerciseAssetCoachInfoDto;
  showTooltip?: boolean;
  size?: number;
}

const ExercisePrivacyBadge = ({
  privacy,
  coach,
  size = 40,
}: IExercisePrivacyBadgeProps) => {
  const tooltip = privacyTooltip(
    "exercise",
    privacy,
    privacy === LibraryPrivacy.TEAM ? coach?.coachName : undefined,
  );

  return (
    <LibraryPrivacyBadge
      privacy={privacy}
      owner={
        coach
          ? {
              photoUrl: coach.coachPhotoUrl,
              displayName: coach.coachName,
            }
          : undefined
      }
      tooltip={tooltip}
      size={size}
      showLabel={false}
    />
  );
};

export default ExercisePrivacyBadge;
